<template>
    <div>
       <h2 class="text-xl font-bold mb-4">Características del Candidato</h2>
       <div class="mb-4">
         <label for="name" class="block text-gray-700 text-sm font-bold mb-2">Nombre:</label>
         <input type="text" id="name" v-model="name" class="w-full p-2 border rounded">
       </div>
       <div class="mb-4">
         <label for="education" class="block text-gray-700 text-sm font-bold mb-2">Estudios:</label>
         <input type="text" id="education" v-model="education" class="w-full p-2 border rounded">
       </div>
        <div class="mb-4">
         <label for="experience" class="block text-gray-700 text-sm font-bold mb-2">Experiencia:</label>
         <textarea id="experience" v-model="experience" class="w-full p-2 border rounded"></textarea>
       </div>
   </div>
 </template>
 <script>
 export default {
      props: ['setCandidateDetails', 'candidateDetails'],
      data(){
       return{
           name: this.candidateDetails.name,
           education: this.candidateDetails.education,
           experience: this.candidateDetails.experience
       }
     },
     watch:{
         name(newValue){
            this.setCandidateDetails({name:newValue})
         },
         education(newValue){
            this.setCandidateDetails({education:newValue})
         },
          experience(newValue){
            this.setCandidateDetails({experience:newValue})
         }
     }
 }
 </script>